exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".subject-name{background:#fff;font-size:24px;padding-left:10px;padding-top:10px;margin-bottom:5px}.transition-all{transition:all .3s}.collapse-layout{padding:0 23px}.collapse-header-header{padding-left:20px!important}.collapse-header-title{line-height:38px;font-size:1pc;float:left}.collapse-header-bars{font-size:22px;line-height:38px!important;display:inline-block!important;position:absolute;right:10px}.collapse-content-title{font-size:15px;padding:5px 0 5px 20px}.ant-collapse-content,.ant-collapse-content>.ant-collapse-content-box{padding:0!important}.collapse-padding{padding-top:30px}.ant-menu-inline>.ant-menu-item,.ant-menu-inline>.ant-menu-submenu>.ant-menu-submenu-title,.ant-menu-item-group-list>.ant-menu-item,.ant-menu-item-group-list>.ant-menu-submenu>.ant-menu-submenu-title,.ant-menu-vertical>.ant-menu-item,.ant-menu-vertical>.ant-menu-submenu>.ant-menu-submenu-title{font-size:15px!important}.mediaType-query-label{color:#666a7d}.all-collection{z-index:10;position:fixed;right:20px;height:60px;width:60px;cursor:pointer;bottom:90pt;color:#fff;background:#3166ff;padding:9pt 18px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/modules/search/components/style.css
 ** module id = 1762
 ** module chunks = 0
 **/